import { Amplify } from 'aws-amplify'
import awsconfig from './aws-exports'

// aws-exports.jsから設定を読み込んでAmplifyを初期化
try {
  Amplify.configure(awsconfig, { ssr: false })
  
  // 設定が正しく適用されたか確認
  const config = Amplify.getConfig()
  if (config?.Auth?.Cognito) {
    // eslint-disable-next-line no-console
    console.log('Amplify configured successfully from aws-exports.js')
    // グローバルフラグで設定完了を示す
    window.__amplifyConfigured__ = true
    // グローバルにAmplifyインスタンスも保存
    window.__amplify__ = Amplify
    // 設定もグローバルに保存
    window.__amplifyConfig__ = awsconfig
  } else {
    // eslint-disable-next-line no-console
    console.error('Amplify configuration failed - config not applied')
  }
} catch (error) {
  // eslint-disable-next-line no-console
  console.error('Amplify configuration error:', error)
}

export default Amplify
